module.exports = __webpack_public_path__ + "media/images/nav/icon_13-ee04d81c24351c61cb7a035341fc6f53.svg";